import { useEffect } from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const CallbackMyAccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { login, setLoginError } = useAuth();

  const params = new URLSearchParams(location.search);
  console.log("Params: "+params)
  const code = params.get('code');
  const error = params.get('error');
  const errorDescription = params.get('error_description');
  const state = params.get('state');
  const storedState = sessionStorage.getItem('state');

  useEffect(() => {
    // Early exit for error from provider or bad state
  if (error || !code || !state || storedState !== state) {
    const errorMessage = error
      ? `${error}: ${errorDescription || 'No additional error description provided.'}`
      : 'Invalid code or state.';
    setLoginError(errorMessage);
    return <Navigate to="/login2" replace />;
  }
    const handleCallback = async () => {
      const codeVerifier = sessionStorage.getItem('code_verifier');
      if (!codeVerifier) {
        const msg = 'Code verifier is missing.';
        setLoginError(msg);
        console.error(msg);
        return navigate('/login2');
      }

      try {
        const response = await fetch(`/api/auth/myaccess`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            code:code,
            codeVerifier:codeVerifier
          }),
          credential: 'include',
        });
        const responseData = await response.json();

        if (response.status === 200) {
          console.log('Token exchange successful:', responseData);
          const idToken = responseData.data.id_token;
          if (idToken) {
            login(idToken, responseData.email, responseData.roles);
            setLoginError(null);
            console.log("Successful");
            sessionStorage.setItem('receivedState', state); // optional if you use it
            navigate('/');
          } else {
            console.error('ID token missing in response');
            const errorMessage = responseData?.error?.message || responseData?.message || `Login failed (${response.status})`;
            setLoginError(errorMessage);
            navigate('/login2');
          }
        } else {
          console.error(`Login failed: ${response.statusText}`);
          const errorMessage = responseData?.error?.message || responseData?.message || `Login failed (${response.status})`;
          setLoginError(errorMessage);
          navigate('/login2');
        }
      } catch (err) {
        console.error('MyAccess callback error:', err);
        setLoginError('Network error during login. Please check your connection and try again.');
        navigate('/login2');
      }
    };

    handleCallback();
  }, [code, state, login, setLoginError, navigate]);

  return <div>Processing login with MyAccess...</div>;
};

export default CallbackMyAccess;